module.exports = __webpack_public_path__ + "img/qrcode.151e010d.png";